import React, { useState } from "react";
import { CONTACT_US } from "../hooks/APIHooks";

const ContactForm = () => {
  const [honeypot, setHoneypot] = useState("");
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (honeypot) {
      console.warn("Bot detected! Submission blocked.");
      return;
    }

    try {
      const response = await fetch(CONTACT_US, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (result.success) {
        alert("Form submitted successfully!");
        setFormData({ name: "", email: "", phone: "", subject: "", message: "" });
      } else {
        alert(result.error || "Submission failed.");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("An unexpected error occurred. Please try again later.");
    }
  };

  return (
    <section
      id="contact"
      className="min-h-screen flex items-center justify-center bg-primary"
    >
      <div className="p-6 mx-auto max-w-xl bg-white rounded-md shadow-md font-[sans-serif]">
        <h1 className="text-3xl text-black font-bold text-center mb-4">
          Get in Touch
        </h1>
        <p className="text-lg text-gray-600 text-center mb-8">
          We'd love to hear from you! Please fill out the form below to get in
          touch with us.
        </p>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="flex flex-col">
            <input
              type="text"
              name="honeypot"
              value={honeypot}
              onChange={(e) => setHoneypot(e.target.value)}
              style={{ display: "none" }} // Hide the field from real users
            />

            <label className="text-lg text-gray-600 mb-2">Name:</label>
            <input
              type="text"
              name="name"
              placeholder="John Doe"
              value={formData.name}
              onChange={handleChange}
              className="py-2.5 px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm outline-none transition-all"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-lg text-gray-600 mb-2">Email:</label>
            <input
              type="email"
              name="email"
              placeholder="john.doe@example.com"
              value={formData.email}
              onChange={handleChange}
              className="py-2.5 px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm outline-none transition-all"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-lg text-gray-600 mb-2">Phone:</label>
            <input
              type="tel"
              name="phone"
              placeholder="+91 9876543210"
              value={formData.phone}
              onChange={handleChange}
              className="py-2.5 px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm outline-none transition-all"
              required
            />
          </div>
          <div className="flex flex-col">
            <label className="text-lg text-gray-600 mb-2">Subject:</label>
            <input
              type="text"
              name="subject"
              placeholder="Hello World"
              value={formData.subject}
              onChange={handleChange}
              className="py-2.5 px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm outline-none transition-all"
              required
            />
          </div>

          <div className="flex flex-col">
            <label className="text-lg text-gray-600 mb-2">Message:</label>
            <textarea
              name="message"
              placeholder="Type your message here..."
              rows="4"
              value={formData.message}
              onChange={handleChange}
              className="px-4 text-gray-800 bg-gray-100 border focus:border-black focus:bg-transparent text-sm pt-3 outline-none transition-all"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className="text-white bg-black hover:bg-gray-900 tracking-wide text-sm px-4 py-2.5 w-full outline-none"
          >
            Send
          </button>
        </form>
      </div>
    </section>
  );
};

export default ContactForm;
